import { get } from "../methods";
function getDashboardFeed(payload, headers = {}) {
  return get({
    url: `dashboard/events${payload.refresh ? "?refresh=1" : ""}`,
    headers
  });
}
export {
  getDashboardFeed as default
};
